<template>
  <div style="display:none"></div>
</template>

<script>
import fields from '@/mixins/fields.js'
export default {
  name: 'PrewarmLoader',
  mixins: [fields],
  mounted(){
    const done = this.$store.getters.getDataInitDone
    if (!done) {
      // Kick off dataset parsing and caching once at app start
      setTimeout(this.setUpData, 50)
    }
  }
}
</script>

<style scoped>
</style>

